interface EnvelopeError {
    response?: { status?: number; data?: { errors?: Array<string> } };
}

/** Human-readable message for a failed inbox settings request ({ success, data, errors } envelope). */
export const inboxRequestErrorMessage = (error: unknown, fallback: string): string => {
    const { response } = (error as EnvelopeError) ?? {};
    const backendErrors = response?.data?.errors?.filter(Boolean) ?? [];

    if (backendErrors.length > 0) return backendErrors.join(' ');
    if (response?.status === 404) return 'This option is not available yet in this environment.';
    return fallback;
};
